<template>
  <div>
    <v-dialog v-model="active" persistent width="500">
      <v-card>
        <v-btn
          aria-label="Lukk"
          absolute
          right
          icon
          class="mt-4"
          @click="emitDialogClosedEvent"
        >
          <v-icon>mdi-close-circle-outline</v-icon>
        </v-btn>
        <v-card-title class="headline" primary-title>Åpne kart</v-card-title>

        <v-card-text>
          <p>
            Klikk på et kart i listen under for å åpne kartet. Du kan fjerne
            kart fra listen ved å klikke på søppelbøtteikonet.
          </p>

          <v-tabs slider-color="primary" v-model="activeTab">
            <v-tab
              ripple
              v-for="(projectCategory, index) in projectCategories"
              :key="index"
              >{{ projectCategory.title }}</v-tab
            >
            <v-tab-item
              v-for="(projectCategory, index) in projectCategories"
              :key="index"
            >
              <v-card flat>
                <v-card-text
                  v-if="
                    projectCategory.hasOwnProperty('projects') &&
                      projectCategory.projects.length > 0
                  "
                >
                  <v-text-field
                    v-show="projectCategory.projects.length > 5"
                    label
                    clearable
                    hide-details
                    class="secondary"
                    single-line
                    absolute
                    v-model="search"
                    style="position: sticky;top: 0px; z-index: 100; "
                    placeholder="Søk.."
                    box
                  ></v-text-field>
                  <v-list two-line>
                    <template
                      v-for="(project, index) in projectCategory.projects"
                    >
                      <v-list-tile
                        v-show="
                          search === null ||
                            search === '' ||
                            project.attributes.tittel
                              .toLowerCase()
                              .includes(search.toLowerCase())
                        "
                        :class="{
                          'highlight-project':
                            project.attributes.GlobalID ==
                            (selectedProject
                              ? selectedProject.attributes.GlobalID
                              : null),
                        }"
                        avatar
                        :key="project.attributes.GlobalID"
                        @click="selectProject(project)"
                      >
                        <v-list-tile-avatar>
                          <v-icon>folder</v-icon>
                        </v-list-tile-avatar>
                        <v-list-tile-content>
                          <v-list-tile-title>
                            {{ project.attributes.tittel }}
                          </v-list-tile-title>
                          <v-list-tile-sub-title>
                            Sist endret:
                            {{
                              project.attributes.EditDate
                                | moment("dddd, Do MMMM YYYY")
                            }}
                          </v-list-tile-sub-title>
                        </v-list-tile-content>
                        <v-spacer />
                        <v-list-tile-action>
                          <v-tooltip left>
                            <template v-slot:activator="{ on }">
                              <v-btn
                                @click.stop="
                                  showConfirmRemoveFromListDialog(project)
                                "
                                v-on="on"
                                fab
                                small
                                icon
                              >
                                <v-icon>mdi-delete-outline</v-icon>
                              </v-btn>
                            </template>
                            <span>Fjern fra liste</span>
                          </v-tooltip>
                        </v-list-tile-action>
                      </v-list-tile>
                      <v-divider
                        v-if="index != privateProjects.length - 1"
                        :key="project.attributes.GlobalID + 'divider'"
                      ></v-divider>
                    </template>
                  </v-list>
                </v-card-text>
                <v-card-text v-else>
                  <p v-show="!loadingSavedProjects">
                    Du har ingen lagrede eller delte kart.
                  </p>
                  <v-layout
                    align-center
                    justify-center
                    v-show="loadingSavedProjects"
                    row
                  >
                    <v-progress-circular
                      indeterminate
                      color="primary"
                    ></v-progress-circular>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs>

          <p class="ml-2">
            Lenker til lagrede og delte kart lagres kun i nettleseren din. Klikk
            'Last ned kopi av delte og lagrede kart' for å sikkerhetskopiere
            kartene til din datamaskin. Du kan importere kartene (f.eks. i en
            annen nettleser) ved å klikke 'Importer delte og lagrede kart fra
            fil' og velge kopien/filen.
          </p>
          <v-btn outline @click="downloadLastVisitedMapsAsFile"
            >Last ned kopi av delte og lagrede kart</v-btn
          >
          <v-btn outline @click="$refs.fileImportVisistedMapsBackup.click()"
            >Importer delte og lagrede kart fra fil</v-btn
          >

          <input
            v-show="false"
            aria-label="Importer sist besøkte kart"
            type="file"
            @change="importLastVisitedMaps"
            ref="fileImportVisistedMapsBackup"
            id="fileImportVisistedMapsBackup"
            name="files"
          />
        </v-card-text>

        <v-divider></v-divider>

        <!-- <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            flat
            color="primary"
            :disabled="selectedProject == null"
            @click="checkNeedForSavingExistingProject"
            >Åpne valgt kart</v-btn
          >
          <v-btn flat @click="emitDialogClosedEvent">Avbryt</v-btn>
        </v-card-actions> -->
      </v-card>
    </v-dialog>

    <confirm-dialog
      :active="confirmDialog"
      :text="saveExisitingProjectDialogText"
      title="Lagre kart"
      confirm-text="Ja"
      reject-text="Nei"
      @dialog-confirmed="saveExistingProjectAndOpenSelected"
      @dialog-rejected="openProject"
    />

    <confirm-dialog
      :active="confirmRemoveFromListDialog"
      :text="confirmRemoveFromListDialogText"
      title="Fjern kart fra liste"
      confirm-text="Ja"
      reject-text="Nei"
      @dialog-confirmed="removeMapFromList"
      @dialog-rejected="resetRemoveFromListDialog"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import MappingMixin from "@/mixins/mappingMixin";
import ConfirmDialog from "@/components/ConfirmDialog";

export default {
  name: "OpenProjectDialog",
  components: { ConfirmDialog },
  mixins: [MappingMixin],
  computed: {
    ...mapState([
      "currentlyOpenedProject",
      "userIsLoggedIn",
      "userAccount",
      "lastVisitedMaps",
    ]),
    privateProjects() {
      return this.savedMaps.filter((savedProject) => {
        if (this.userAccount == null) {
          return false;
        } else {
          return (
            savedProject.attributes.eier == this.userAccount.accountIdentifier
          );
        }
      });
    },
    publicProjects() {
      return this.savedMaps
        .filter((savedProject) => {
          if (this.userAccount == null) {
            return true;
          } else {
            return (
              savedProject.attributes.eier !==
              this.userAccount.accountIdentifier
            );
          }
        })
        .sort((a, b) => {
          return b.attributes.EditDate - a.attributes.EditDate;
        });
    },
    projectCategories() {
      return [
        {
          title: "Delte og lagrede kart",
          projects: this.publicProjects,
          requiresLogin: false,
        },
      ];
    },
    saveExisitingProjectDialogText() {
      if (this.currentlyOpenedProject) {
        return (
          "Ønsker du å lagre endringene i kartet '" +
          this.currentlyOpenedProject.attributes.tittel +
          "'?"
        );
      } else {
        return "";
      }
    },
    confirmRemoveFromListDialogText() {
      if (this.mapToRemoveFromList !== null) {
        return (
          "Er du sikker på at du ønsker å fjerne kartet " +
          this.mapToRemoveFromList.attributes.tittel +
          " fra listen? Merk: Denne handlingen kan ikke angres."
        );
      } else {
        return "";
      }
    },
  },
  data: () => ({
    dialog: false,
    confirmDialog: false,
    savedMaps: [],
    mapToRemoveFromList: null,
    selectedProject: null,
    confirmRemoveFromListDialog: false,
    activeTab: null,
    loadingSavedProjects: false,
    search: "",
  }),
  props: {
    active: Boolean,
  },
  watch: {
    active: function(newVal) {
      if (newVal == true) {
        this.getSavedProjects();
        this.activeTab = 0;
      }
    },
  },
  methods: {
    ...mapActions(["setSnack", "removeLastVisitedMap", "addLastVisitedMap"]),
    emitDialogClosedEvent() {
      this.$emit("close-dialog");
    },
    showConfirmRemoveFromListDialog(map) {
      this.mapToRemoveFromList = map;
      this.confirmRemoveFromListDialog = true;
    },
    removeMapFromList() {
      this.removeLastVisitedMap({
        id: this.mapToRemoveFromList.attributes.GlobalID,
      });
      let index = this.savedMaps.findIndex(
        (map) =>
          map.attributes.GlobalID ===
          this.mapToRemoveFromList.attributes.GlobalID
      );
      this.savedMaps.splice(index, 1);
      this.resetRemoveFromListDialog();
    },
    resetRemoveFromListDialog() {
      this.mapToRemoveFromList = null;
      this.confirmRemoveFromListDialog = false;
    },
    getSavedProjects() {
      this.loadingSavedProjects = true;
      this.savedMaps = [];

      let promises = [];

      this.lastVisitedMaps.forEach((lastVisitedMap) => {
        promises.push(this.getProjectByID(lastVisitedMap.id));
      });

      Promise.all(promises).then((results) => {
        this.loadingSavedProjects = false;
        results.forEach((result) => {
          if (typeof result !== "undefined") this.savedMaps.push(result);
        });
      });
    },
    downloadLastVisitedMapsAsFile() {
      var a = document.createElement("a");
      var file = new Blob([JSON.stringify(this.lastVisitedMaps)], {
        type: "application/json",
      });
      a.href = URL.createObjectURL(file);
      a.download = "NVE_temakart_lagrede_kart_backup.json";
      a.click();
    },
    importLastVisitedMaps(evt) {
      var files = evt.target.files; // FileList object
      var f = files[0];
      var reader = new FileReader();

      // Closure to capture the file information.
      reader.onload = (() => {
        return (e) => {
          // Render thumbnail.
          let JsonObj = JSON.parse(e.target.result);

          if (
            JsonObj !== null &&
            JsonObj.hasOwnProperty("length") &&
            JsonObj.length > 0
          ) {
            JsonObj.forEach((visitedMap) => {
              this.addLastVisitedMap(visitedMap);
            });
            this.getSavedProjects();
            document.getElementById("fileImportVisistedMapsBackup").value = "";
          }
        };
      })(f);

      // Read in the image file as a data URL.
      reader.readAsText(f);
    },
    selectProject(project) {
      this.selectedProject = project;
      project.isSelected = true;
      this.checkNeedForSavingExistingProject();
    },
    checkNeedForSavingExistingProject() {
      this.emitDialogClosedEvent();
      if (this.currentlyOpenedProject !== null && this.saveIsEnabled) {
        this.openConfirmDialog();
      } else {
        this.openProject();
      }
    },
    closeConfirmDialog() {
      this.confirmDialog = false;
    },
    openConfirmDialog() {
      this.confirmDialog = true;
    },
    saveExistingProjectAndOpenSelected() {
      this.closeConfirmDialog();
      this.saveMap(this.currentlyOpenedProject).then(() => {
        this.openProject();
      });
    },
    userHasPrivilegesToSave(project) {
      if (
        this.userAccount !== null &&
        this.userAccount.accountIdentifier === project.attributes.eier
      ) {
        return true;
      } else {
        let lastVisitedMap = this.lastVisitedMaps.find((lastVisitedMap) => {
          return (
            lastVisitedMap.id.toLowerCase() ===
            project.attributes.GlobalID.toLowerCase()
          );
        });

        if (
          typeof lastVisitedMap !== "undefined" &&
          lastVisitedMap.hash ===
            project.attributes.GlobalID.toLowerCase().hashCode()
        ) {
          return true;
        } else {
          return false;
        }
      }
    },
    openProject() {
      this.closeConfirmDialog();

      this.openSavedMap({
        map: this.selectedProject,
        allowSave: this.userHasPrivilegesToSave(this.selectedProject),
      });
      this.setSnack(
        "Åpnet kart '" + this.selectedProject.attributes.tittel + "'"
      );
    },
  },
  mounted() {
    this.getSavedProjects();
  },
};
</script>

<style scoped>
.highlight-project {
  background: lightgray;
}
</style>
